import React from "react";

export default function StrikeIco(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="-5 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>strike</title>
      <path d="M0 15.25h21.875v1.938h-21.875v-1.938zM11.563 13.25l2 1.063h-7.969c-0.563-0.844-0.906-1.875-0.906-3.031-0.031-3.625 2.781-6.094 7.406-6.094 1.031 0 2.344 0.125 3.625 0.5 0.406 0.125 0.719 0.188 1.094 0.25 0.25 0.719 0.563 2.438 0.563 4.563 0 0-1.219 0.094-1.25 0.094-0.531-1.625-1.906-3.938-4.188-3.938-2.125 0-3.25 1.375-3.25 2.969 0 1.469 1.281 2.781 2.875 3.625zM13.844 22.563c0-2.063-1.563-3.469-3.188-4.438h6.969c0.344 0.75 0.563 1.625 0.563 2.656 0 3.938-3.219 6.469-8.063 6.469-2.906 0-4.75-0.813-5.406-1.188-0.625-0.719-1.031-3-1.031-5.188l1.219-0.094c0.625 2.063 2.781 5 5.5 5 2.344 0 3.438-1.625 3.438-3.219z"></path>
    </svg>
  );
}
